import * as React from 'react';
import Row from 'components/Row';
import Text from 'components/Text';
import Link from 'components/Link';
import Menu from 'components/Menu';
import MenuItem from 'components/MenuItem';
import MenuButton from 'components/MenuButtonDeprecated';
import TextWithIcon from 'components/TextWithIcon';

import LinkConstants from 'constants/LinkConstants';

type IntegrationType = {
  organizationUUID: string;
  canEdit: boolean;
  onActionUnauthorized: () => void;
  toggleClickHandler?: () => void;
  isToggleable?: boolean;
  isEnabled?: boolean;
  providerKey: string;
  title: string;
};

type AdminIntegrationEmbedProps = {
  onActionUnauthorized: () => void;
  organizationUUID: string;
  remindPlanIntegrations: Array<IntegrationType>;
};

export default function AdminIntegrationEmbed(props: AdminIntegrationEmbedProps) {
  const integrationMenuItems: React.ReactNode[] = props.remindPlanIntegrations.map(
    ({ providerKey, title }) => {
      const menuItemProps = {
        menuKey: providerKey,
        to: `/install_lti/${props.organizationUUID}/${providerKey}`,
        onclick: props.onActionUnauthorized,
      };

      return (
        <MenuItem key={providerKey} {...menuItemProps}>
          {title}
        </MenuItem>
      );
    }
  );

  const otherMenuItemProps = {
    menuKey: 'other',
    to: `/install_lti/${props.organizationUUID}/other`,
    onclick: props.onActionUnauthorized,
  };

  return (
    <Row size="xsmall">
      <div className="AdminIntegratedToolsView-embed">
        <div>
          <Text weight="semibold" size="medium">
            Embed Remind in your LMS
          </Text>
          <Text element="div" color="graphite">
            Send Remind messages from inside your LTI-enanabled LMS.{' '}
            <Link href={LinkConstants.ADMIN_INTEGRATIONS_HELP} target="_blank" weight="semibold">
              Learn More
            </Link>
          </Text>
        </div>
        <MenuButton
          key="menu"
          size="xsmall"
          level="primary"
          alignment="right"
          placement="bottom"
          menu={
            <Menu>
              {integrationMenuItems}
              <MenuItem key="other" {...otherMenuItemProps}>
                Other
              </MenuItem>
            </Menu>
          }>
          <TextWithIcon appendIcon icon="chevron-down" iconSize="small">
            Set Up
          </TextWithIcon>
        </MenuButton>
      </div>
    </Row>
  );
}
